import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FeatureProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Feature/${props.featureId}`, method: 'GET', secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `Feature/Franchise`, method: 'POST', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'Feature', method: 'GET', secure: true });
    }, [execute]);  

    const value = { selectRecord, listRecords, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFeatureStore = () => React.useContext(Context);
